import { createSlice } from '@reduxjs/toolkit'
import { getPeriods } from './periodsThunk';
import { Period } from '../../../interfaces/Periods';

interface PeriodsState {
    periods: Period[] | null,
    loading: "idle" | "pending" | "succeeded" | "failed";
    lastPeriod: Period | null;         // Último periodo activo (estado === 1) y se modifica con cada nueva selección de setSelect
    latestPeriod: Period | null;       // Último periodo en orden sin importar estado
}

const initialState: PeriodsState = {
    loading: 'idle',
    periods: null,
    lastPeriod: null,
    latestPeriod: null
}

export const periodsSlice = createSlice({
    name: 'periods',
    initialState,
    reducers: {
        setSelectedPeriod: (state, action) => {
            if (!state.periods) {
                return;
            }

            const foundPeriod = state.periods.find((p) =>
                p.value.includes(action.payload.period)
            );

            state.lastPeriod = foundPeriod
                ? { ...foundPeriod, value: foundPeriod.value.replace('Período ', '') }
                : null;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getPeriods.pending, (state) => {
            state.loading = "pending";
        });
        builder.addCase(getPeriods.fulfilled, (state, action) => {
            state.loading = "succeeded";
            state.periods = action.payload.periods;

            const allPeriods = action.payload.periods;

            const lastActivePeriod = allPeriods
                .filter((p: Period) => p.estado === 1)
                .at(-1);

            const lastAnyPeriod = allPeriods.at(-1);

            if (!state.lastPeriod) {
                state.lastPeriod = lastActivePeriod
                    ? { ...lastActivePeriod, value: lastActivePeriod.value.replace('Período ', '') }
                    : null;
            }

            state.latestPeriod = lastAnyPeriod
                ? { ...lastAnyPeriod, value: lastAnyPeriod.value.replace('Período ', '') }
                : null;
        });
        builder.addCase(getPeriods.rejected, (state) => {
            state.loading = "failed";
        });
    }
})

export const { setSelectedPeriod } = periodsSlice.actions;

export default periodsSlice.reducer;